"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _baseClient = _interopRequireDefault(require("./baseClient"));

var _environments = require("../constants/environments");

var MerchantConfigClient =
/*#__PURE__*/
function (_BaseClient) {
  (0, _inherits2["default"])(MerchantConfigClient, _BaseClient);

  function MerchantConfigClient(_ref) {
    var _this;

    var _ref$environment = _ref.environment,
        environment = _ref$environment === void 0 ? _environments.PRODUCTION : _ref$environment,
        accessToken = _ref.accessToken;
    (0, _classCallCheck2["default"])(this, MerchantConfigClient);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MerchantConfigClient).call(this, {
      accessToken: accessToken
    }));
    _this.baseUrl = "https://".concat(environment === _environments.PRODUCTION ? '' : 'int-', "merchant-config.commerce.cimpress.io");
    return _this;
  }

  (0, _createClass2["default"])(MerchantConfigClient, [{
    key: "getMerchant",
    value: function () {
      var _getMerchant = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee(merchantId) {
        var response, merchant;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetch("".concat(this.baseUrl, "/v0/merchants/").concat(merchantId), {
                  headers: this.headers
                });

              case 3:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 6;
                  break;
                }

                throw new Error("react-claims: Failed to retrieve display name for ".concat(merchantId));

              case 6:
                _context.next = 8;
                return response.json();

              case 8:
                merchant = _context.sent;
                return _context.abrupt("return", {
                  merchant: merchant
                });

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0.message);
                return _context.abrupt("return", {
                  merchant: {
                    merchantId: merchantId,
                    displayName: merchantId
                  },
                  error: _context.t0
                });

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 12]]);
      }));

      function getMerchant(_x) {
        return _getMerchant.apply(this, arguments);
      }

      return getMerchant;
    }()
  }]);
  return MerchantConfigClient;
}(_baseClient["default"]);

exports["default"] = MerchantConfigClient;